
import { createNamespacedHelpers } from 'vuex';
import respUtility from '@/mixins/respUtility';

const { mapState, mapMutations } = createNamespacedHelpers('listing');

export default {
  name: 'ListingResults',
  mixins: [respUtility],
  props: {
    loading: {
      type: Object,
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
    items: {
      type: Array,
      default() { return []; },
    },
  },
  data: () => ({
    desktopFiltersVisible: true,
    activeSortFilter: false,
    scrollEndTimer: null,
    isScrolling: false,
  }),
  computed: {
    ...mapState(['searchParams']),
    isLoading() {
      return Object.values(this.loading || {}).some((n) => n > 0);
    },
  },
  mounted() {
    this.resizeHandler();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.resizeHandler);
    }
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.resizeHandler);
    }
    this.clearListeners();
  },
  watch: {
    '$vuetify.breakpoint.mdAndDown': function closeMenu() {
      this.activeSortFilter = false;
    },
    activeSortFilter(status) {
      const wrapper = document.documentElement;
      if (status) {
        wrapper?.classList.add('search-page-no-scroll');
        document.querySelector('body')?.classList.add('search-page-no-scroll');
        window.addEventListener('scroll', this.scrollHandler);
        visualViewport.addEventListener('scroll', this.scrollViewport);
      } else {
        this.clearListeners();
      }
    },
  },
  methods: {
    ...mapMutations(['setSortingSticky']),
    clearListeners() {
      document.documentElement?.classList.remove('search-page-no-scroll');
      document.querySelector('body')?.classList.remove('search-page-no-scroll');
      window.removeEventListener('scroll', this.scrollHandler);
      if (window.visualViewport) {
        visualViewport.removeEventListener('scroll', this.scrollViewport);
      }
      window.removeEventListener('scroll', this.handleScroll);
    },
    scrollViewport() {
      this.isScrolling = true;
      clearTimeout(this.scrollEndTimer);
      this.scrollEndTimer = setTimeout(() => {
        this.$taskManager.append(() => {
          const offsetTop = window.visualViewport
            ? window.visualViewport.offsetTop
            : document.documentElement.offsetTop;
          document.documentElement?.style.setProperty('--listing-top', `${offsetTop}px`);
          this.isScrolling = false;
        });
      }, 100);
    },
    resizeHandler() {
      this.$taskManager.append(() => {
        const clientHeight = window.visualViewport
          ? window.visualViewport.height
          : document.documentElement.clientHeight;
        document.documentElement?.style.setProperty('--listing-height', `${clientHeight}px`);
      });
    },
    scrollHandler(event) {
      if (this.activeSortFilter) {
        this.isScrolling = true;
        event.preventDefault();
        this.$taskManager.append(() => {
          const inputs = document.querySelectorAll('[id*="filtersinput"]');
          const active = Array.from(inputs).find((i) => i === document.activeElement);
          window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
          if (active) {
            active.scrollIntoView({ behavior: 'instant', block: 'center' });
          }
          this.isScrolling = false;
        });
      }
    },
    toggleDesktopFilters() {
      if (!(this.$device.isMobileOrTablet || this.isTouchDevice)) {
        this.desktopFiltersVisible = !this.desktopFiltersVisible;
      }
    },
    handleScroll() {
      const container = this.$refs.resultsContainer;
      const rect = container.getBoundingClientRect();
      if (rect.top <= 0 && rect.bottom >= 0) {
        this.setSortingSticky(true);
      } else {
        this.setSortingSticky(false);
      }
    },
    changeActiveFilter() {
      this.activeSortFilter = true;
      if (!this.$isSpider && (this.$device.isMobileOrTablet || this.isTouchDevice)
        && document.getElementById('merchantwidget-iframe-wrapper')) {
        document.getElementById('merchantwidget-iframe-wrapper').style.display = 'none';
      }
    },
  },
};
